//Componentes a los cuales se va dar acceso en la navegacion 
import Home from '../Componentes/Home/Home';
import NotFound from '../Componentes/NotFound/NotFound';
import { GnlNombreModulo } from './Llaves/RepositorioConfig';

const RutasComponente = {
    Rutas: [],
    RutaHome: {
        component: Home,
        path: "/home",
        opt: "Home"
    },
    RutaNotFound: {
        component: NotFound,
        path: "/auth/NotFound",
        opt: "NotFound"
    },
    Modulo: GnlNombreModulo
};

export default RutasComponente;